// src/redux/actions.js
import { createAction } from '@reduxjs/toolkit';

export const resetState = createAction('resetState');
